export const DEFAULT_ICON = {
  identifier: "shape-circle-blue",
  emoji_type: "shapes",
} as const;
